import { SortDirection } from '@angular/material/sort';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PAGE_SIZE_DEFAULT } from '../../_common/constants';
import { DailyReportListResponse } from './daily-reports.model';

@Injectable({
  providedIn: 'root'
})

export class DailyReportsService {
  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
  ) { }

  getDailyReports(pageIndex: number = 0, pageSize: number = PAGE_SIZE_DEFAULT, sortBy: string, sortDir: SortDirection, filter: any): Observable<DailyReportListResponse> {
    return this.http
      .post<DailyReportListResponse>(
        this.apiUrl + 'dailyReport/daily-reports',
        {
          pageNumber: pageIndex,
          pageSize,
          sortBy,
          sortDir,
          filter: JSON.stringify(filter)
        }
      );
  }

  getImage(id: number)
  {
    return this.http.get(`${this.apiUrl}dailyReport/image/${id}`, { observe: 'response', responseType: 'text' });
  }
}
